{
    "confirm": {
        "confirmToDeleteMediaAndRemoveFromProjects": "Wissen en uit het project verwijderen | Wissen en uit het project verwijderen",
        "unsavedChanges": "Niet-opgeslagen wijzigingen!",
        "areYouSureYouWantToRemovePage": "Verwijder '{pageName}'.",
        "deleteStyle": "Stijl verwijderen?",
        "deleteMedia": "Media verwijderen?",
        "deleteMediaImplications": "Wissen en uit projecten verwijderen?",
        "deletePlayer": "Player verwijderen?",
        "deletePlayerImplications": "Deze actie verwijdert de speler van je ARYA-account en verwijdert alle instellingen gerelateerd aan deze speler, inclusief alle planningen.",
        "permanentlyDeleteTheUserAccount": "Account verwijderen.",
        "removeTemplate": "Sjabloon verwijderen",
        "removeTemplateDesc": "Wil je dit sjabloon uit deze Stijl verwijderen?",
        "removeTheMediaFromTheSchedule": "Uit schema verwijderen.",
        "mediaNamesIsInUploadStateAndWillPermanentlyDelete": "Media verwijderen.",
        "mediaUsedInProject": "Media gebruikt in project | Media gebruikt in projecten",
        "confirmPassword": "Wachtwoord bevestigen",
        "changeEmail": "E-mail wijzigen",
        "deleteOrder": "Bestelling verwijderen",
        "deleteTag": "Tag verwijderen?",
        "deletePopId": "PoP ID verwijderen?",
        "deleteUser": "Gebruiker verwijderen?",
        "deleteAccount": "Account verwijderen?",
        "leaveAccount": "Account verlaten?",
        "deleteCanvasResolution": "Canvasresolutie verwijderen?",
        "downloadLicense": "Licentie downloaden?",
        "cancelOrder": "Bestelling annuleren?",
        "removeAccessFromArya": "Toegang van ARYA verwijderen?",
        "deleteTemplate": "Sjabloon verwijderen?"
    },
    "signinup": {
        "new": "Nieuw bij {productNameShort}?",
        "newUser": "Nieuwe gebruiker"
    },
    "label": {
        "aryaAccountID": "Arya-account-ID",
        "accountId": "Account-ID",
        "admin": "beheerder",
        "playerName": "Spelernaam",
        "playerModel": "Spelermodel",
        "addPlayer": "Speler toevoegen",
        "assignCodeHasAlreadyBeenAssignedInAnotherAccountErrorMessage": "De code {code} is al toegewezen aan een ander account.",
        "assignCodeHasAlreadyBeenAssignedErrorMessage": "De code {code} is al toegewezen.",
        "account": "Account | Accounts",
        "accountInfo": "Informatie over het account",
        "accountInformation": "Informatie over het account",
        "accountName": "Naam account",
        "accountPlan": "Accountplan",
        "accountCorrespondent": "Overeenkomstig account",
        "accountIsDeleted": "Het account is verwijderd",
        "activate": "activeren",
        "address": "adres",
        "alert": "alarm | alarmen",
        "amount": "bedrag",
        "apply": "toepassen",
        "assign": "toewijzing | toewijzingen",
        "audio": "audio",
        "auto": "auto",
        "basic": "basis",
        "bannerText1": "Gepland onderhoud",
        "bannerText2": "We zullen op {date} om {time} een gepland onderhoud ondergaan gedurende ongeveer {approximateHours} uur lang . Onze excuses voor het eventuele ongemak gedurende deze tijd.",
        "bannerText3": "Tijdens onderhoud zal {productName} niet beschikbaar zijn voor inhoudswijzigingen, maar spelers zullen hun inhoud blijven weergeven.",
        "billing": "facturering",
        "billingDetails": "Factuurgegevens",
        "buy": "kopen",
        "comment": "opmerking",
        "companyInformation": "Bedrijfsinformatie",
        "contentNotSupported": "inhoud niet ondersteund, klik voor meer informatie...",
        "copy": "kopie | kopieën",
        "configPending": "CONFIG HANGENDE",
        "configError": "CONFIG FOUT",
        "credentials": "inloggegevens",
        "credentialsNotValid": "Inloggegevens niet geldig",
        "createStyle": "Stijl aanmaken",
        "createUserExistErrorMessage": "{email} is al lid van dit account.",
        "createUserLimitReached": "Gebruikerslimiet bereikt",
        "creditCard": "Creditcard",
        "download": "Downloaden",
        "extended": "verlengd",
        "expirationDate": "Vervaldatum",
        "expires": "verloopt",
        "language": "Taal",
        "learnMore": "meer informatie",
        "leaveAccount": "Account verlaten",
        "leaveAccountWithOnlyOneUserMessage": "U kunt het account niet verlaten omdat u de enige gebruiker in het account bent.",
        "leaveAccountTheOnlyAdminInTheAccountMessage": "U kunt het account niet verlaten omdat u de enige beheerder van het account bent.",
        "leaveAccountImplicationsCommonMessage": "Deze actie zal u uit deze account verwijderen.",
        "license": "vergunning",
        "limited": "beperkt",
        "location": "Locatie",
        "login": "Inloggen",
        "loginError": "Er is iets fout gegaan, we kunnen u op dit moment niet aanmelden, probeer het later opnieuw of neem contact op met uw beheerder",
        "loginWith": "Inloggen met",
        "loginString2": "Onmiddellijk nhoud op het scherm. Gratis.",
        "loginString3": "Eenvoud ontmoet digitale bewegwijziging.",
        "loginString4": "Bestel en activeer functiepakketten naadloos",
        "loginOKStringTitle2": "Eenvoud ontmoet smart synch.",
        "loginOKStringDesc1": "Pas het aan. Plan het. Geef het voorrang.",
        "loginOKStringDesc2": "Tag het. Smart Sync het. Waarschuw, indien nodig.",
        "loginOKString4": "Volgende stap. Snelle player-setup.",
        "loginOKString5": "U heeft enkel het serienummer van uw speler nodig.",
        "loginOKQuotaWarnMain": "Gratis opslag {percentage}% vol.",
        "loginOKQuotaWarnSub": "Upgrade naar  {plan} voor volledig aanpasbare sjablonen en waarschuwingen, 10 GB opslag per speler, 10 gebruikers, labels en smart sync-labels, en nog veel meer.",
        "loginOKQuotaReachedMain": "Gratis opslag {percentage}% vol.",
        "loginOKQuotaReachedSub": "Upgrade naar  {plan} voor volledig aanpasbare sjablonen en waarschuwingen, 10 GB opslag per speler, 10 gebruikers, labels en smart sync-labels, en nog veel meer.",
        "loginOKQuotaExcededMain": "Gratis opslag vol.",
        "loginOKQuotaExcededSub": "Upgrade naar  {plan} voor voor volledig aanpasbare sjablonen en waarschuwingen, 10 GB opslag per speler, 10 gebruikers, labels en smart sync-labels, en nog veel meer.",
        "logoutOKStringTitle1": "U BENT NU AFGEMELD",
        "logoutOKStringDesc1": "U kunt zich opnieuw aanmelden door op onderstaande knop te klikken.",
        "notice": "bericht",
        "playerSetupString1": "Creëer uw project.",
        "playerSetupString2": "Het is supereenvoudig. Het is supersnel.",
        "playerSetupString3": "label.spelerConfiguratieString3",
        "payments": "betalingen",
        "pageNotFound": "Sorry, pagina niet gevonden",
        "plan": "plan | plannen",
        "popIdentifier": "PoP-IDENTIFICATIE",
        "postalCode": "Postcode",
        "purchasePlanUpgradeSuccessMain": "Welkom bij {plan}",
        "purchasePlanDowngradeSuccessMain": "Account is bijgesteld naar {planName}",
        "loggedOffInFewSeconds": "Je wordt binnen enkele seconden afgemeld",
        "termsOfServiceString1": "Servicevoorwaarden",
        "termsOfServiceString2": "Laatst bijgewerkt: 9 januari 2019",
        "termsOfServiceString3": "Download en lees het volgende document",
        "termsOfServiceString4": "SERVICEVOORWAARDEN",
        "termsOfServiceString5": "PRIVACYBELEID",
        "termsOfServiceString6": "Selecteer ACCEPTEREN om door te gaan.",
        "accept": "accepteren",
        "all": "Allemaal",
        "allPlayers": "Alle spelers",
        "add": "Toevoegen",
        "setPassword": "Bevestigen",
        "support": "ondersteunen",
        "cancel": "annuleren",
        "canvasSize": "Canvasgrootte: {size} pixels",
        "canvasExistsError": "Canvas met deze grootte bestaat al",
        "cardType": "kaarttype",
        "cardNumber": "kaartnummer",
        "change": "veranderen",
        "clickToEdit": "klik om te bewerken",
        "city": "stad",
        "color": "kleur | kleuren",
        "company": "bedrijf",
        "companyName": "Bedrijfsnaam",
        "confirm": "Bevestigen",
        "confirmation": "Bevestiging",
        "warning": "Waarschuwing",
        "codeIsRequired": "Verificatiecode vereist",
        "code": "Code",
        "contact": "contact",
        "country": "land",
        "create": "Aanmaken",
        "checkThePlayer": "Verbinden met het internet. Sluit aan op spanning.",
        "checkDetails": "Details controleren",
        "chooseHorizontalOrVerticalScreenOrientations": "Kies de oriëntatie van het scherm",
        "continue": "Doorgaan",
        "conctactSystemAdmin": "Neem contact op met uw systeembeheerder.",
        "date": "datum",
        "deactivate": "deactiveren",
        "default": "standaard",
        "dropFilesHere": "Zet hier bestanden neer",
        "delete": "verwijderen",
        "deleteAccount": "account verwijderen",
        "deleteAccountWithMultipleUsersMessage": "U moet alle andere gebruikers verwijderen voordat u dit account kunt verwijderen.",
        "deleteAccountWithDistributorRightsMessage": "Dit account kan niet worden verwijderd. Het is eigendom van een distributeur.",
        "deleteAccountTitleThisActionWill": "Deze actie zal",
        "deleteAccountImplications": {
            "deleteAccount": "1. Account verwijderen",
            "deleteUser": "2. Gebruiker verwijderen"
        },
        "youCannotDeleteUserAsOnlyUserInAccount": "U kunt geen gebruiker verwijderen omdat u de enige gebruiker bent in het account.",
        "deleteUser": "gebruiker verwijderen",
        "deleteOnAllPlayers": "op ALLE SPELERS VERWIJDEREN.",
        "deleteFromSchedule": "Uit schema verwijderen ",
        "demoVersion": "Demoversie",
        "disable": "uitschakelen",
        "disabled": "uitgeschakeld",
        "distributor": "verdeler",
        "downgradeAccount": "Account downgraden",
        "downgradeTo": "Downgrade naar {plan}",
        "duplicate": "Dupliceren",
        "duplicateFile": "Bestand dupliceren",
        "duplicateInSchedule": "Dupliceren in schema",
        "duration": "Looptijd",
        "adsDuration": "Advertentieduur",
        "error": "fout",
        "email": "e-mail",
        "emailAlreadyExists": "Het nieuwe e-mailadres wordt al door een andere gebruiker gebruikt, gelieve een ander te gebruiken.",
        "enable": "inschakelen",
        "enabled": "ingeschakeld",
        "endDate": "Einde",
        "endTime": "Einde",
        "end": "einde",
        "edit": "Bewerken",
        "editProject": "Project bewerken",
        "feedbackForm": "Feedback geven",
        "firstName": "Voornaam",
        "firmwareUpdate": "UPDATE FIRMWARE",
        "failed": "Contact opnemen met ondersteuning",
        "file": "Bestand | Bestanden",
        "forgotPassword": "Wachtwoord vergeten",
        "formatNotSupported": "'{format}' bestanden niet ondersteund.",
        "firmware": "Firmware",
        "freeVersion": "Gratis versie",
        "freeVersionNA": "Gratis versie n.v.t.",
        "get": "krijgen",
        "getCode": "Ontvang config",
        "getConfig": "Ontvang Config",
        "generateNewAPIKey": "Nieuwe API-sleutel genereren",
        "generateUserAPIKeyWarningMessage": "Deze actie zal de vorige API-sleutel ongeldig maken, elke bestaande verbinding met de API zal opnieuw geconfigureerd moeten worden om de nieuwe API-sleutel te gebruiken.",
        "goBack": "Ga terug",
        "goToLogin": "Ga naar inloggen",
        "helpCenter": "Helpcentrum",
        "horizontalView": "Horizontaal beeld",
        "image": "Afbeelding | Afbeeldingen",
        "implications": "gevolgen",
        "implicationsDeleteTag": "Deze actie zal dit label uit alle {deleteFrom} verwijderen. Dit kan gevolgen hebben voor uw gebruikersrechten en planning.",
        "implicationsDeleteLedTag": "Deze actie verwijdert dit label van alle spelers. Elke speler die dit label had, zal opnieuw geconfigureerd moeten worden om inhoud met deze resolutie opnieuw te kunnen publiceren.",
        "implicationsDeletePopId": "Deze actie zal deze PoP-ID overal waar hij wordt gebruikt, verwijderen.",
        "importantToNote": "Belangrijk om op te merken",
        "logo": "logo",
        "userProfile": "Gebruikersprofiel",
        "userSignOut": "Afmelden",
        "userNotConfirmed": "Gebruiker niet bevestigd",
        "userNotFound": "Gebruiker bestaat niet. Zorg ervoor dat dit account bestaat",
        "userManagement": "Gebruikersmanagement",
        "id": "id",
        "incorrectUsername": "Incorrecte e-mail",
        "incorrectPassword": "Incorrect wachtwoord",
        "installed": "Geïnstalleerd",
        "installedOrCapacity": "Geïnstalleerd / Capaciteit",
        "installedOrCapacityUnlimitedMaxValue": "van onbeperkte spelers",
        "invalidEmail": "Ongeldige e-mail",
        "invalidPassword": "Ongeldig wachtwoord",
        "invalidUserdata": "Contact opnemen met ondersteuning",
        "invalidSerialNumber": "Ongeldig serienummer",
        "invalidResolution": "Ongeldige resolutie",
        "invalidDSOSTypeAmount": "Ongeldige waarde, voer een getal in.",
        "invoice": "factuur | facturen",
        "inviteUser": "Gebruiker uitnodigen",
        "keyboardShortcuts": "Sneltoetsen",
        "requiredDeviceName": "Naam vereist",
        "regular": "regelmatig",
        "resetPassword": "Wachtwoord opnieuw instellen",
        "loading": "Bezig met laden...",
        "lastName": "Achternaam",
        "lastLogin": "Laatste aanmelding",
        "modify": "wijzigen",
        "monitoring": "toezicht houden",
        "newPassword": "Nieuw wachtwoord",
        "newPasswordRequiredWarning": "Stel uw wachtwoord in",
        "confirmNewPassword": "Bevestig nieuw wachtwoord",
        "new": "Nieuw",
        "newCanvas": "Nieuw canvas",
        "newProject": "nieuw project",
        "newEmail": "Nieuwe e-mail",
        "newResolution": "Nieuwe resolutie",
        "name": "naam",
        "naText": "N.v.t.",
        "next": "volgende",
        "nextRenewalDate": "Volgende vernieuwing {renewalDate}",
        "noVideoAvailable": "Geen video beschikbaar.",
        "noEmailProvided": "Geen e-mail verstrekt",
        "none": "geen",
        "noSearchResults": "geen resultaten",
        "noPermissionToAccessThePage": "Toegang geweigerd",
        "noPlayersInstalled": "Geen spelers geïnstalleerd",
        "noPlayerGroupsAvailable": "Geen spelersgroepen beschikbaar",
        "notConfigured": "Setup vereist",
        "nameYourPlayerEGReception": "Geef uw speler een naam, bijvoorbeeld Onthaal",
        "ok": "oké",
        "or": "of",
        "order": "bestelling | bestellingen",
        "orders": "bestellingen",
        "offline": "Offline",
        "online": "online",
        "options": "opties",
        "page": "Pagina",
        "player": "speler | spelers",
        "playerGroups": "Spelersgroepen",
        "pleaseEnterACity": "Stad invoeren",
        "pin": "pincode",
        "pinShownOnYourScreen": "Pincode weergegeven op uw scherm",
        "playTime": "Speeltijd",
        "PleaseTryAgainOrHeadBackToTheHomepage": "Probeer opnieuw of ga terug naar de startpagina",
        "playerIsNotConnectedToTheCloud": "Verkeerd serienummer",
        "pleaseTryAgain": "Probeer het opnieuw",
        "pleaseEnterThePin": "Pincode vereist",
        "pleaseEnterValidPin": "Voer het 4 of 6-cijferige nummer in dat op uw scherm wordt weergegeven",
        "pinMustBeFourDigitNumber": "Pin-code moet 4 tot 6 cijfers bevatten",
        "pinMustBeAtleastOneThousand": "De PIN-code moet minstens 1000 zijn",
        "pleaseCheckYourEmailForVerificationCode": "Verificatiecode is naar uw e-mail verzonden.",
        "password": "wachtwoord",
        "passwordDidNotMatch": "Wachtwoord komt niet overeen",
        "passwordCannotBeReset": "Wachtwoord kan niet worden gereset",
        "passwordHasBeenChanged": "Uw wachtwoord is gewijzigd",
        "passwordAttemptLimitExceeded": "Limiet voor het invoeren overschreden, probeer het na enige tijd opnieuw.",
        "passwordPolicyRequirementText": "Het wachtwoord moet 8 of meer tekens lang zijn, met hoofdletters, kleine letters, cijfers en speciale tekens.",
        "price": "Prijs",
        "priceSlashMonth": "Prijs / Maand",
        "priority": "prioriteit",
        "privacy": "Privacy",
        "project": "Project | Projecten",
        "projectName": "Projectnaam",
        "profile": "Profiel",
        "proofOfPlay": "Bewijs van spelen",
        "preview": "Voorbeeld",
        "previewUnavailable": "Voorbeeld niet beschikbaar",
        "proceed": "doorgaan",
        "publishTo": "Publiceren op",
        "releaseNotes": "Versie-informatie",
        "remove": "verwijderen",
        "removeUserFromAccount": "gebruiker van account verwijderen",
        "replace": "vervangen",
        "reporting": "verslaglegging",
        "reset": "resetten",
        "restart": "opnieuw starten",
        "resolution": "oplossing",
        "reactivate": "opnieuw activeren",
        "resetPasswordDescription": "Voer een e-mailadres in om verificatiecode te ontvangen",
        "resetPasswordCodeSent": "Verificatiecode verzonden naar uw e-mail",
        "resetPasswordCodeSentIfAccountExist": "ALS HET ACCOUNT BESTAAT",
        "requiredAccountName": "Accountnaam vereist",
        "requiredEmail": "Email vereist",
        "requiredCountry": "Land vereist",
        "requiredPassword": "Wachtwoord vereist",
        "requiredConfirmPassword": "Bevestiging wachtwoord vereist",
        "requiredFirstName": "Voornaam verplicht",
        "requiredLastName": "Achternaam vereist",
        "requiredName": "Naam vereist",
        "requiredUsername": "E-mail vereist",
        "requiredVerificationCode": "Verificatiecode vereist",
        "requiredSerialNumber": "Serienummer vereist",
        "requiredCity": "Stad vereist",
        "requiredState": "Staat vereist",
        "requiredZipOrPostalCode": "Postcode vereist",
        "requiredStreetAndNumber": "Straat en nummer vereist",
        "requiredCompanyName": "Bedrijfsnaam vereist",
        "requiredDataStorageRegion": "Gegevensopslagregio vereist",
        "invalidDataStorageRegion": "Ongeldige gegevensopslagregio",
        "review": "controleren",
        "search": "Zoek op",
        "addressSearchPlaceholder": "Typ adres om spelers te lokaliseren",
        "searching": "zoeken",
        "signOut": "afmelden",
        "status": "status",
        "save": "bewaren",
        "reconfigure": "De installatie herstarten",
        "saveAs": "Opslaan als",
        "saveChanges": "Wijzigingen opslaan",
        "savedStyles": "Opgeslagen stijlen",
        "schedule": "planning",
        "scheduledToTag": "Gepland om te labelen",
        "screen": "scherm",
        "screenOn": "Scherm aan",
        "screenOrientation": "Schermoriëntatie",
        "security": "Veiligheid",
        "sendCode": "Code verzenden",
        "sendEmail": "Verzenden",
        "sendInvitation": "Uitnodiging verzenden",
        "sendTo": "Verzenden naar",
        "serial": "Serienummer",
        "serialNumber": "Serienummer",
        "serialNumberAlreadyAssigned": "Serienummer al toegewezen",
        "select": "SELECTEREN",
        "selectAll": "alles selecteren",
        "selectLanguage": "taal selecteren",
        "setup": "Instellen",
        "settings": "instellingen",
        "shapeColors": "Kleuren vorm",
        "shareWithText": "{productShortName} Digitale bewegwijziging. Eenvoudig. Slim. Krachtig.",
        "signIn": "Aanmelden",
        "signUp": "Inschrijven",
        "signUpErrorMessageAccountEmailExist": "Er bestaat al een account met het opgegeven e-mailadres.",
        "slowSync": "TRAGE SYNC ",
        "sorry": "Sorry.",
        "streetAndNumber": "Straat en nummer",
        "success": "succes",
        "summary": "samenvatting",
        "somethingWentWrong": "Er is iets fout gegaan",
        "song": "Lied | Liedjes",
        "startDate": "Startdatum",
        "startTime": "Start",
        "start": "Start",
        "state": "staat",
        "steps": "stappen",
        "styleName": "Naam stijl",
        "storage": "opslag",
        "subtotal": "subtotaal",
        "subscription": "abonnement",
        "subscriptionMonthlyAutoRenew": "Maandelijks (automatische verlenging)",
        "ssoLoginErrorTitle": "Er is iets fout gegaan, we kunnen u op dit moment niet aanmelden, probeer het later opnieuw of neem contact op met uw beheerder",
        "ssoMigrateAccountStep1Title1": "Er bestaat al een account voor {email}.",
        "ssoMigrateAccountStep1Title2": "U kunt het wijzigen om over te stappen naar een  {provider} SSO.",
        "ssoMigrateAccountStep1Title3": "Ga verder om de overstap te bevestigen.",
        "ssoMigrateAccountStep2Title1": "Zodra u de overstap naar {provider} SSO bevestigt,",
        "ssoMigrateAccountStep2Title2": "functioneert uw vorige aanmelding niet meer.",
        "ssoMigrateAccountStep2Title3": "Deze actie kan niet ongedaan gemaakt worden.",
        "ssoMigrateAccountVerifyTitle1": "We moeten uw bestaande {email}-account verifiëren.",
        "ssoMigrateAccountVerifyTitle2": "Meld u aan met dat account om door te gaan.",
        "tag": "label | labels",
        "defaultTags": "Standaardlabels",
        "text": "tekst",
        "timeZone": "Tijdzone",
        "time": "tijd",
        "timeShorthandSecond": "SEC",
        "timeShorthandMinute": "MIN",
        "timeShorthandHour": "U",
        "template": "Sjabloon | Sjablonen",
        "temporaryPassword": "tijdelijk wachtwoord",
        "tempPasswordExpiredPleaseContactAdmin": "Het tijdelijke wachtwoord is verlopen. Neem contact op met uw beheerder",
        "total": "totaal",
        "tutorial": "Tutorial | Tutorials",
        "user": "gebruiker | gebruikers",
        "userAPIKey": "API-sleutel",
        "userNotActive": "Gebruiker niet actief",
        "usernameShouldBeValidEmail": "Gebruikersnaam moet een geldig e-mailadres zijn",
        "updatedAccountInfo": "Uw accountgegevens zijn bijgewerkt.",
        "updatedCustomerInfo": "Uw klantgegevens zijn bijgewerkt.",
        "updatedProfile": "Uw gebruikersprofiel is bijgewerkt.",
        "updated": "bijgewerkt",
        "upload": "Upload",
        "upgrade": "opwaarderen",
        "upTime": "opstarttijd",
        "video": "Video",
        "vat": "BTW",
        "verificationCode": "Verificatiecode",
        "verticalView": "Verticale weergave",
        "yourPlan": "uw plan",
        "withResolution": "met een resolutie van {resolution}",
        "youHaveLeftAccount": "Je hebt de account verlaten",
        "zipOrPostalCode": "postcode",
        "mon": "Ma",
        "tue": "Din",
        "wed": "Wo",
        "thu": "Don",
        "fri": "Vri",
        "sat": "Za",
        "sun": "Zon",
        "custom": "aangepast",
        "customerInfo": "Klantgegevens",
        "apps": "apps",
        "multiplePopIdsNotAllowed": "Elk bestand mag slechts één bewijs van spel-identificatie hebben.",
        "forbidden": "Er is iets misgegaan en we konden uw verzoek niet voltooien. U wordt zo doorgestuurd naar de homepage.",
        "dataStorageRegion": "Gegevensopslagregio",
        "verificationSentToEmailIfExist": "Verificatiecode verzonden naar uw e-mail (als account bestaat)",
        "alreadyHaveAnAccountRedirect": "Heb je al een account? {linkStart}Inloggen{linkEnd}",
        "emailText": "E-mail",
        "passwordText": "Wachtwoord",
        "signupWith": "Aanmelden met",
        "setNewPassword": "Wachtwoord instellen",
        "passwordHint": "{minStart}Minimaal 8 tekens,{minEnd} {upStart}hoofdletter,{upEnd} {lowStart}kleine letter,{lowEnd} {numStart}nummer{numEnd}{numSpecialSeparatorStart} & {numSpecialSeparatorEnd}{spStart}speciaal teken{spEnd}.",
        "home": "Startpagina",
        "loginWithName": "Aanmelden met {name}",
        "signupWithName": "Registreren met {name}",
        "fileType": "Bestandstype",
        "lastModified": "Laatst gewijzigd",
        "images": "Afbeeldingen",
        "videos": "Video's",
        "projectsOrPdf": "Projecten / PDF",
        "elementiProject": "Elementi-projecten",
        "scheduled": "Gepland",
        "notScheduled": "Niet gepland",
        "from": "Van",
        "to": "Tot",
        "fileTypes": "Bestandstypen",
        "contentStatus": "Contentstatus",
        "modifiedDate": "Wijzigingsdatum",
        "filters": "Filters",
        "sortBy": "Sorteren op",
        "sort": "Sorteren",
        "lastModifiedDesc": "Laatst gewijzigd (nieuwste eerst)",
        "lastModifiedAsc": "Laatst gewijzigd (oudste eerst)",
        "nameAsc": "Naam (A → Z)",
        "nameDesc": "Naam (Z → A)",
        "grid": "Raster",
        "canvas": "Canvas",
        "audioPlaylist": "Afspeellijst audio",
        "isAlertActive": "Alert actief",
        "active": "Actief",
        "inactive": "Inactief",
        "filesPage": "Bestandenpagina",
        "ledPage": "LED-pagina",
        "videowallPage": "Videowall-pagina",
        "alertPage": "Meldingenpagina"
    },
    "buttons": {
        "backToProduct": "Terug naar {productName}",
        "reload": "Herladen",
        "previous": "Vorige",
        "next": "Volgende",
        "loadMore": "Meer laden",
        "addNewUser": "Nieuwe gebruiker toevoegen",
        "apply": "Toepassen",
        "clearAll": "Alles wissen",
        "reset": "Resetten",
        "tryItNow": "Probeer het nu",
        "switchBack": "Terugschakelen",
        "cancel": "Annuleren",
        "deleteMedia": "Media verwijderen",
        "deletePlayer": "Speler verwijderen",
        "deleteTag": "Tag verwijderen",
        "deletePopId": "PoP ID verwijderen",
        "deleteUser": "Gebruiker verwijderen",
        "continueWithoutSaving": "Doorgaan zonder opslaan",
        "close": "Sluiten",
        "cancelOrder": "Bestelling annuleren",
        "removeUser": "Gebruiker verwijderen",
        "deleteTemplate": "Sjabloon verwijderen",
        "deleteStyle": "Stijl verwijderen",
        "ok": "OK",
        "delete": "Verwijderen",
        "keepBoth": "Beide behouden",
        "replaceExistingFile": "Bestaand bestand vervangen",
        "replaceExistingFiles": "Bestaande bestanden vervangen"
    },
    "texts": {
        "youAreLoggingIn": "Je bent ingelogd met",
        "productAccessDisabled": "U heeft geen toegang tot {product}",
        "productAccessDisabledWarning": "U heeft geen toegang tot {product} voor het account {account}.\n\nU heeft mogelijk geen toegang gekregen tot dit product, of uw toegang is ingetrokken door de Global Admin. Neem contact op met de Global Admin voor meer informatie of om toegang aan te vragen.\n\nU kunt doorgaan met het gebruik van andere producten waarvoor u toestemming heeft binnen dit account.",
        "tablePageCountWTotal": "Weergave van {min}{separator}{max} van {total}",
        "tablePageCountWoutTotal": "Weergave van {min}{separator}{max}",
        "dataStorageRegionHint": "Kies de regio waar uw accountgegevens worden opgeslagen. Deze beslissing moet aansluiten bij uw lokale wetgeving voor gegevensbescherming en compliance-eisen. Let op: eenmaal geselecteerd, kan de dataresidentie-regio later niet meer worden gewijzigd.",
        "welcomeToHUB": "Welkom bij SpinetiX HUB!",
        "welcomeToHUBDesc": "SpinetiX HUB is uw alles-in-één online platform voor het beheren van alles wat gerelateerd is aan uw SpinetiX digital signage in de cloud.",
        "hubGlobalAdmin": "SpinetiX Global Admin",
        "hubGlobalAdminDesc": "Deze gebruiker is een Global Admin op de HUB, wat hem automatisch de Admin-rol in ARYA verleent. Deze roltoewijzing kan niet worden gewijzigd.",
        "removeAccessFromAryaTitle": "Toegang tot ARYA verwijderen?",
        "removeAccessFromAryaMessage": "Hiermee wordt alleen de toegang van {userName} tot ARYA verwijderd.",
        "removeAccessFromAryaByNonGlobalAdmin": "Neem contact op met uw Global Admin om de gebruiker uit het HUB-account te verwijderen.",
        "removeAccessFromAryaByGlobalAdmin": "Ze behouden toegang tot andere producten in dit HUB-account.\n\nOm de gebruiker uit het HUB-account te verwijderen, gaat u naar {link}",
        "hubUserManagement": "HUB-gebruikersbeheer",
        "goToHUBUserManagement": "ga naar het HUB-gebruikersbeheer.",
        "noContentHasBeenScheduledYet": "Er is nog geen inhoud gepland.",
        "emptyFilterTablePlaceholder": "We konden geen items vinden die overeenkomen met uw zoekopdracht. Probeer uw zoektermen aan te passen en probeer het opnieuw!",
        "requestId": "Verzoek-ID:",
        "externalSignInMessage": "U bent aangemeld via een externe identiteitsprovider (bijv. Google, Facebook of SSO met een andere identiteitsprovider). Uw inloggegevens, waaronder {email} en {password}, worden beheerd door die provider.",
        "youHaveUnsavedChanges": "U heeft niet-opgeslagen wijzigingen.",
        "waitForUploadingFile": "Bestand wordt geüpload, even geduld...",
        "defaultTagsNote": "Projecten erven de labels van het stijlpakket wanneer ze vanuit de sjabloon worden gemaakt. Als u later labels toevoegt aan of verwijdert uit het stijlpakket, worden bestaande projecten niet bijgewerkt.",
        "seeAll": "Alles bekijken",
        "allPlayTimes": "Alle afspeeltijden"
    },
    "unsupportedBrowser": {
        "bannerTitle": "Uw browser wordt niet ondersteund",
        "bannerMessage": "U gebruikt een browser die niet wordt ondersteund. Sommige functies werken mogelijk niet correct. Schakel voor de beste ervaring met ons product over op {highlightStart}Google Chrome{highlightEnd} of {highlightStart}Microsoft Edge{highlightEnd}."
    },
    "switchedAccount": {
        "title": "Account gewijzigd",
        "desc1": "Welkom terug.",
        "switch": "overstappen",
        "text1": "Account gewijzigd",
        "text2": "naar {account}"
    },
    "plans": {
        "downgradedToFreeDesc": "{plan} plan is nu ingeschakeld. Aan het einde van de factureringscyclus wordt uw creditcard een laatste keer in rekening gebracht",
        "free": "Gratis",
        "tags": "SMART SYNC & LABELS",
        "sharedStorage": "gedeelde opslag",
        "custom": "Custom en waarschuwingen",
        "playerStorage": "Speleropslag",
        "playerPerMonth": "speler / maand | spelers / maand",
        "review": {
            "termsAndConditionsMain": "Door uw bestelling te plaatsen gaat u akkoord met",
            "termsAndConditionsSub": "SpinetiX-voorwaarden en verkoopvoorwaarden"
        }
    },
    "filters": {
        "images": "afbeeldingen",
        "videos": "videos",
        "audio": "audio",
        "projectsOrPdf": "projecten / PDF",
        "scheduled": "gepland",
        "elementiProject": "elementi-projecten"
    },
    "template": {
        "24H": "24 uur",
        "AM/PM": "AM/PM",
        "addPage": "Pagina toevoegen",
        "arrowSettings": "Pijlinstellingen",
        "back": "Terug",
        "background": "Achtergrond",
        "both": "Beide",
        "bottom": "beneden",
        "center": "midden",
        "cellSettings": "celinstellingen",
        "clock": "klok",
        "clockSettings": "Klokinstellingen",
        "countdown": "aftellen",
        "countdownSettings": "Instellingen aftellen",
        "custom": "aangepast",
        "changeMedia": "Media veranderen",
        "default": "standaard",
        "duplicatePage": "de pagina dupliceren",
        "date": "datum",
        "days": "dagen",
        "effects": "Effecten",
        "fade": "Vervagen",
        "fill": "vullen",
        "front": "Voor",
        "frameFitting": "Aanpassen aan kader",
        "hours": "uren",
        "imageEffects": "Afbeeldingseffecten",
        "kenBurns": "Ken Burns",
        "noEffect": "Geen effect",
        "noBorder": "Geen kader",
        "noMargin": "Geen marge",
        "L": "L",
        "large": "groot",
        "left": "Links",
        "local": "lokaal",
        "long": "lang",
        "M": "M",
        "meet": "ontmoeten",
        "media": "media",
        "menu": "menu",
        "mediatable": "mediatafel",
        "middle": "Midden",
        "month": "maand",
        "overlay": "overlay",
        "overview": "overzicht",
        "playOnce": "Eenmaal spelen",
        "qr": "qr",
        "reg": "reg",
        "repeat": "herhalen",
        "right": "Rechts",
        "rss": "RSS",
        "shape": "vorm",
        "shapeSettings": "Vorminstellingen",
        "shapeSettingsHint": "Tip: Begin met typen om tekst toe te voegen",
        "slice": "plak",
        "slide": "Dia",
        "small": "klein",
        "smart": "smart",
        "S": "S",
        "time": "Tijd",
        "timeAndDate": "TIJD + DATUM",
        "tableSettings": "Tabelinstellingen",
        "text": "tekst",
        "textSettings": "Tekstinstellingen",
        "top": "top",
        "wayfinding": "bewegwijzering",
        "weather": "weer",
        "html": "webpagina",
        "url": "url",
        "videoin": "Video-In",
        "videoWidth": "videobreedte",
        "videoHeight": "videohoogte",
        "videoSettings": "Video-instellingen",
        "frameRate": "framesnelheid",
        "frameWidth": "Breedte selecteren",
        "format": "formaat",
        "error": {
            "invalidLink": "Ongeldige link"
        },
        "placeholder": {
            "url": "Voer URL in"
        },
        "weatherIconSettings": "Instellingen weerpictogram",
        "weatherLocationSettings": "Instellingen weerlocatie",
        "weatherLocationSettingsHint": "Tip: Typ de naam van de locatie",
        "webpageSettings": "Instellingen webpagina",
        "qrSettings": "QR-instellingen",
        "rssSettings": "RSS-instellingen",
        "rssSettingsTooltip": "RSS feeds aangeboden door {productName} zijn afkomstig van <b>externe providers</b>.<br/>We streven ernaar om een gevarieerde selectie van feeds aan te bieden om aan uw behoeften te voldoen; de kwaliteit en prestaties zijn echter volledig afhankelijk van de externe leveranciers.",
        "stream": "Stream",
        "list": "Lijst"
    },
    "templates": {
        "duration": "Looptijd",
        "pageDuration": "Paginaduur",
        "timezone": "Tijdzone",
        "tags": "Labels",
        "playtimes": "Speeltijd",
        "alignElements": "Elementen uitlijnen",
        "removeTemplateConfirmation": "Weet u zeker dat u dit sjabloon uit de stijl \"{styleName}\" wilt verwijderen?",
        "deleteStyleConfirmation": "Weet u zeker dat u de stijl \"{styleName}\" wilt verwijderen?",
        "deleteStyleWarning": "Door deze stijl te verwijderen, verwijdert u alle sjablonen die erin zijn gemaakt.",
        "noTemplatesAvailable": "Geen sjablonen beschikbaar",
        "noStylePackAccess": "U heeft momenteel geen toegang tot stijlpakketten met sjablonen. Stijlpakketten zijn alleen beschikbaar wanneer ze met u worden gedeeld via uw toegewezen machtigingen of labels.\nAls u denkt dat u toegang zou moeten hebben, neem dan contact op met uw accountbeheerder."
    },
    "Hours": {
        "title": "Titel",
        "time": "Uren",
        "media": "Media"
    },
    "Info": {
        "info": "Informatie",
        "title": "Titel",
        "description": "Tekst",
        "media": "Media"
    },
    "Logo": {
        "title": "Tekst"
    },
    "Menu": {
        "title": "Tekst",
        "price": "Prijs",
        "media": "Media",
        "menu": "Menu"
    },
    "News": {
        "news": "Nieuws",
        "title": "Tekst",
        "timezone": "Tijdzone",
        "format": "Formaat",
        "media": "Media"
    },
    "Person": {
        "person": "Persoon",
        "title": "Tekst bovenaan",
        "description": "Tekst onderaan",
        "media": "Media"
    },
    "Product": {
        "product": "Product",
        "title": "Tekst",
        "price": "Prijs",
        "media": "Media"
    },
    "RSS": {
        "rss-news": "RSS-nieuws",
        "rss": "RSS",
        "news": "Nieuws"
    },
    "Weather": {
        "weather": "Weer",
        "locations": "Stad",
        "display": "Weergeven",
        "media": "Media"
    },
    "playerSetup": {
        "navConfirm": "Bevestigen",
        "navFinish": "Beëindigen",
        "navNext": "Volgende",
        "navPrev": "Terug",
        "navCancel": "Annuleren",
        "addPlayerToPlan": "Voeg speler toe aan je plan",
        "currentPlan": "Huidige plan",
        "canvasName": "Naam canvas",
        "canvasVideoNote": "U vindt uw nieuwe canvas in de {canvasType} onder deze naam.",
        "canvasVideoNoteType_led": "LED-sectie",
        "canvasVideoNoteType_videowall": "Video Wall-sectie",
        "canvasSize": "Canvasformaat",
        "canvasSizeFormatted": "{canvasSize} pixels",
        "updateTo": "Bijwerken naar",
        "numberOfPlayers": "Aantal spelers",
        "dialogTitle": "Speler-instelling",
        "onlyDigitsRequired": "Voer alleen cijfers in",
        "serialNumberRequired": "Het serienummer mag niet leeg zijn",
        "incorrectSerialNumber": "Voer een correct serienummer in",
        "incorrectSerialNumberCharacters": "Voer een geldige invoer in. U kunt in dit veld alleen Engelse letters en cijfers gebruiken",
        "incorrectInput": "Onjuiste invoer",
        "playerName": "Naam",
        "playerNamePlaceholder": "Naam van de speler",
        "requiredPlayerName": "Spelersnaam is verplicht",
        "requiredScreenDiagonal": "Schermdiagonaal is vereist",
        "requiredHorizontalBezel": "Horizontale rand/opening is vereist",
        "requiredVerticalBezel": "Verticale rand/opening is vereist",
        "playerTimezoneHint": "Selecteer de tijdzone van de speler",
        "Progress_PIN": "Pin",
        "Progress_Name": "Naam en tijdzone",
        "Progress_DisplaySettings": "Weergave-instellingen",
        "Progress_Application": "Toepassing",
        "Progress_Arrangement": "Schikking",
        "Progress_Adjustments": "Aanpassingen",
        "DisplayOrientation": "Schermoriëntatie",
        "DisplayResolution": "Schermresolutie",
        "DisplayResolutionHint": "Selecteer de schermresolutie",
        "Application": "Applicatie",
        "ApplicationSingleDisplay": "Enkel scherm",
        "ApplicationMirroring": "Spiegelen",
        "ApplicationVideowall": "Videowall",
        "ApplicationAvailable": "* Beschikbaar met",
        "ApplicationAvailbleWithNote": "*Beschikbaar met",
        "screenDiagonal": "Schermdiagonaal",
        "SelectApplication": "Selecteer de applicatie",
        "SelectDisplayOrientation": "Weergavestand selecteren",
        "SelectNumberOfDisplays": "Selecteer het aantal displays",
        "standardScreenOnly": "Alleen standaardscherm (9:16 en 16:9)",
        "OrientationAndResolution": "Oriëntatie- en resolutie-instellingen zijn van toepassing op alle beeldschermen",
        "DisplaysArrangement": "Schermindeling",
        "SelectDisplayArrangement": "Selecteer schermindeling",
        "HorizontalBezel": "Horizontale rand/opening",
        "VerticalBezel": "Verticale rand/opening",
        "OutputResolutions": "Uitvoerresoluties",
        "CannotCreateLEDTag": "Kan geen LED-resolutie maken",
        "CannotCreateVideowallTag": "Kan geen Videowall-canvas maken",
        "UnknownError": "Onbekende fout opgetreden. Probeer het opnieuw of neem contact op met de ondersteuning.",
        "InvalidAdjustmentsForm": "Er zijn invoervalidatiefouten, vul alle velden correct in",
        "CanvasDimensionsError": "Canvasbreedte of -hoogte worden niet correct gegenereerd",
        "playerDeleteConfirmation": "Weet u zeker dat u de speler {playerName} wilt verwijderen?",
        "playerDeleteWarning": "Het verwijderen van de speler verwijdert hem uit uw SpinetiX HUB-account en verwijdert alle bijbehorende instellingen, inclusief planning."
    },
    "planCard": {
        "getPremium": "Ontvang Premium",
        "bestforGettingStarted": "Het beste om te beginnen",
        "discovery": "Ontdekking",
        "free": "Gratis",
        "oneUser": "1 Gebruiker",
        "oneGBStorage": "1 GB opslagruimte",
        "nineTemplates": "9 Sjablonen",
        "yourPlan": "Uw plan",
        "elevateYourDigitalSignage": "Verhoog uw digitale bewegwijzering",
        "premium": "Premium",
        "premiumPlanPrice": "21 CHF",
        "playerPerMonth": "Speler / Maand",
        "tenUsersAndRoles": "10 Gebruikers en gebruikersrollen",
        "tenGBPlayerStorage": "10 GB / Spelersopslag",
        "twelveTemplatesCustomizable": "12 sjablonen / aanpasbaar",
        "twelveApps": "12 apps, inclusief webpagina",
        "elevenApps": "11 Apps",
        "assetGrouping": "Activa groeperen",
        "scheduleAutomation": "Automatisering plannen",
        "priorityScheduling": "Planning met voorrang",
        "alerts": "Waarschuwingen",
        "audio": "Audio",
        "videoWallSupport": "Videowall-ondersteuning*",
        "new": "Nieuw!",
        "withTheNew": "*met de nieuwe"
    },
    "planUpgrade": {
        "errorFetchingInvoice": "Fout bij het ophalen van de factuur. Probeer het opnieuw.",
        "close": "sluiten",
        "getPremium": "Ontvang Premium!",
        "companyName": "Bedrijfsnaam",
        "dialogTitle": "Upgrade plannen",
        "navConfirm": "Bevestigen",
        "navFinish": "BEËINDIGEN",
        "navNext": "Volgende",
        "navPrev": "Terug",
        "navCancel": "Annuleren",
        "VATNumber": "BTW-nummer",
        "Overview": "Overzicht",
        "AccountOwner": "Eigenaar account",
        "CompanyInfo": "Bedrijfsinfo",
        "BillingDetails": "Factureringsgegevens",
        "Payment": "Betaling",
        "tryAgain": "NOG EEN KEER PROBEREN",
        "paymentSuccessful": "Betaling succesvol",
        "welcomeToPremium": "Welkom bij Premium!",
        "paymentFailed": "Betaling mislukt.",
        "selectCountry": "Selecteer land",
        "selectState": "Selecteer staat"
    },
    "licenseOrdering": {
        "yourOrders": "Uw bestellingen",
        "cancelOrder": "BESTELLING ANNULEREN",
        "orderNumber": "Bestelnummer",
        "orderDate": "Datum bestelling",
        "comment1": "Opmerking 1",
        "comment2": "Opmerking 2",
        "close": "SLUITEN",
        "cancelOrderWarning": "Weet u zeker dat u deze bestelling wil annuleren?",
        "noOrdersAvailable": "U hebt geen bestellingen geplaatst",
        "noRecordsFound": "Geen resultaten gevonden voor zoekopdracht \"{query}\"",
        "noRecordsFoundNote1": "Controleer nog een keer op typefouten of fouten in uw zoekopdracht",
        "noRecordsFoundNote2": "Probeer een andere zoekopdracht"
    },
    "fileUpload": {
        "notAllowedToUploadMedia": "Gebruiker mag geen update uitvoeren op media.",
        "hashMD5ComputationError": "Er is iets misgegaan bij het berekenen van de hashMD5.",
        "duplicateFileUploadErrorTitle": "Er bestaat al een bestand met deze naam",
        "multipleDuplicateFileUploadErrorTitle": "Er bestaan al bestanden met deze namen",
        "duplicateFileUploadErrorDescription": "Er bestaat al een bestand met de naam \"{mediaName}\" in uw bibliotheek.",
        "multipleDuplicateFileUploadErrorDescription": "Er bestaan al bestanden met de namen \"{mediaNames}\" in uw bibliotheek.",
        "duplicateFileUploadErrorMessage": "Controleer het/de bestaande bestand(en) en kies wat u met uw nieuwe upload wilt doen.\n{pleaseNote}: Als u het bestaande bestand vervangt, laad de pagina opnieuw nadat de upload is voltooid om de bijgewerkte versie te zien.",
        "duplicateFileUploadPreviewTitle": "Bestaand(e) bestand(en)",
        "pleaseNote": "Let op"
    },
    "downloadLicense": {
        "confirmDownloadLicense": "Weet u het zeker? Deze methode is uitsluitend voor spelers die niet met internet worden verbonden.",
        "confirmDownloadLicenseWarning": "Met deze methode wordt de licentie onmiddellijk gekoppeld aan het serienummer zonder respijtperiode voor wijzigingen."
    },
    "activation": {
        "assign": "TOEWIJZING",
        "yourLicenses": "Uw licenties",
        "comment": "Opmerking",
        "playerSerialNumber": "Serienummer speler",
        "licenseCode": "Licentiecode",
        "activationDate": "Activeringsdatum",
        "license": "Licentie",
        "suspend": "ONDERBREKEN",
        "restore": "HERSTELLEN",
        "download": "DOWNLOADEN",
        "licenseAvailable": "Licentie beschikbaar",
        "licenseLockedToAPlayer": "Licentie zit vast aan een speler",
        "playerSerialNumberRequired": "Code serienummer speler vereist",
        "licenseCodeRequired": "Licentiecode vereist",
        "processing": "Verwerking",
        "waitingForPlayerToConnect": "Wachten tot speler verbinding maakt",
        "noLicensesAvailable": "U hebt geen licenties toegevoegd"
    },
    "resolutionCalculator": {
        "invalidPitch": "Ongeldige pitch",
        "invalidSize": "Ongeldige grootte"
    },
    "legal": {
        "legal": "Wettelijk",
        "endUserLicenseAgreement": "LICENTIEOVEREENKOMST VOOR EINDGEBRUIKERS",
        "generalTermsAndConditionsOfSale": "ALGEMENE VERKOOPVOORWAARDEN",
        "termsOfService": "SERVICEVOORWAARDEN",
        "privacyPolicy": "PRIVACYBELEID",
        "cookieNotice": "BERICHT OVER COOKIES",
        "downloadPDF": "DOWNLOAD PDF"
    },
    "accountSuspended": {
        "bannerTitle": "Uw abonnement is verlopen!",
        "bannerMessage": "Als u wil verlengen, neem dan contact op met uw verkoper."
    },
    "errors": {
        "invalid": {
            "verificationCode": "De opgegeven verificatiecode is ongeldig, probeer het opnieuw.",
            "passwordReset": "Het wachtwoord kan niet worden gereset.",
            "provider": "Ongeldige provider. Probeer het opnieuw.",
            "emailMismatch": "Het ingevoerde e-mailadres komt niet overeen met het account waarnaar u probeert te migreren."
        },
        "existing": {
            "userAlreadyLinked": "Gebruiker is al gekoppeld aan een andere Identity Provider (IdP).",
            "accountInAnotherRegion": "De gebruiker heeft al een account in een andere regio"
        },
        "failedRefreshToken": "U bent uitgelogd. Log opnieuw in om door te gaan.",
        "cannotMigrateAccountInAnotherRegion": "Kan niet migreren naar SSO omdat uw e-mailadres is gekoppeld aan een andere gegevensopslagregio dan het account waarnaar u probeert te migreren.",
        "nonSSOAuthDenied": "Authenticatie via een niet-SSO-provider is niet toegestaan.",
        "ssoMigrationFailed": "Toegang geweigerd: Je kunt niet overschakelen naar SSO omdat je account al is gekoppeld aan een andere Identity Provider (IdP). Neem contact op met je beheerder voor verdere hulp.",
        "loginUnexpectedError": "Inloggen is mislukt door een onverwachte fout. Probeer het opnieuw.",
        "unexpectedError": "Er is een onverwachte fout opgetreden. Laad de pagina opnieuw.",
        "somethingWentWrong": "Het lijkt erop dat er iets mis is gegaan ({errorCode})",
        "somethingWentWrongDescription": "Er is iets misgegaan bij het laden van deze pagina.<br><br><strong>Wat u kunt doen:</strong><br>Vernieuw de pagina en probeer het opnieuw.<br>Als het nog steeds niet laadt, neem dan contact op met de ondersteuning en deel het onderstaande verzoek-ID.",
        "failedToUpdateAccountInfo": "Kan accountgegevens niet bijwerken.",
        "failedToFetchLicenses": "Licenties ophalen mislukt.",
        "failedToDownloadLicense": "Licentie downloaden mislukt.",
        "failedToDownloadFile": "Bestand downloaden mislukt.",
        "failedToFetchUserInfo": "Gebruikersinformatie ophalen mislukt",
        "failedToFetchPlaces": "Plaatsen ophalen mislukt",
        "fileNotSupported": "Bestandstype niet ondersteund."
    },
    "regionNames": {
        "eu": "Europese Unie / European Union",
        "ch": "Zwitserland / Switzerland",
        "us": "Verenigde Staten / United States",
        "ca": "Canada / Canada",
        "au": "Australië / Australia",
        "hk": "Hongkong / Hong Kong",
        "sg": "Singapore / Singapore"
    },
    "zendesk": {
        "chatCouldNotBeLoaded": "Chat kon niet worden geladen",
        "chatCouldNotBeLoadedDescription": "We konden de ondersteuningschat niet laden. Dit wordt meestal veroorzaakt door de privacy- of cookie-instellingen van je browser. Voor instructies over het inschakelen van de ondersteuningschat, klik hier: {url}."
    },
    "media": {
        "mediaUploadSuccessTitle": "Je media wordt voorbereid…",
        "mediaUploadSuccessMessage": "Het wordt mogelijk niet weergegeven in de huidige weergave vanwege actieve filters of sortering.",
        "mediaViewLegacyToV2Title": "Opnieuw ontworpen mediapagina's",
        "mediaViewV2ToLegacyTitle": "U gebruikt het nieuwe ontwerp!",
        "mediaViewSwitcherDescription": "Snellere navigatie, filters en sortering.",
        "mediaDeleteConfirmation": "Weet u zeker dat u het medium \"{mediaName}\" wilt verwijderen?",
        "multipleMediaDeleteConfirmation": "Weet u zeker dat u de {mediaCount} geselecteerde media-items wilt verwijderen?",
        "mediaDeleteWarning": "Als u dit medium verwijdert, wordt het ook uit elk project verwijderd.",
        "multipleMediaDeleteWarning": "Als u deze media-items verwijdert, worden ze ook verwijderd uit elk project waarin ze worden gebruikt.",
        "mediaFileUploadInfoMessage": "Als u deze niet in uw huidige weergave ziet, kunnen ze verborgen zijn door actieve filters of sortering.",
        "mediaIsReady": "Uw media is gereed!",
        "mediaIsReadyWithCount": "Uw media is gereed! ({count} van {total})",
        "someFilesUploadError": "Enkele bestanden konden niet worden verwerkt",
        "failedUploadError": "Uw bestanden konden niet worden verwerkt. Probeer ze opnieuw te uploaden.",
        "failedUploadErrorTitle": "We konden uw media niet verwerken"
    },
    "leaveAccount": {
        "leaveAccountConfirmation": "Weet u zeker dat u het account [{accountName}] wilt verlaten?",
        "leaveAccountWarning": "Door dit account te verlaten, verliest u de toegang tot het account en alle bijbehorende producten en diensten die momenteel beschikbaar zijn."
    },
    "led": {
        "deleteCanvasConfirmation": "Weet u het zeker? Deze actie verwijdert deze canvasresolutie van alle spelers.",
        "deleteCanvasWarning": "Elke speler die deze canvasresolutie heeft gebruikt, moet opnieuw worden geconfigureerd voordat inhoud met dezelfde resolutie er opnieuw op kan worden gepubliceerd."
    },
    "popId": {
        "deletePopIdConfirmation": "Weet u het zeker? Deze actie verwijdert dit PoP ID overal waar het wordt gebruikt."
    },
    "tag": {
        "deleteTagConfirmation": "Weet u het zeker? Deze actie verwijdert deze tag van alle {source}.",
        "deleteTagWarning": "Dit kan uw gebruikersrechten en planning beïnvloeden."
    },
    "userProfile": {
        "permanent": "permanent",
        "deleteUserConfirmation": "U staat op het punt uw gebruikersprofiel te verwijderen. Deze actie is {permanent} en kan niet ongedaan worden gemaakt.",
        "lose": "verliezen",
        "deleteUserWarning": "Door verder te gaan, zal u {lose} de toegang tot alle accounts en producten die aan uw gebruikersgegevens zijn gekoppeld.\nWeet u zeker dat u wilt doorgaan?"
    }
}
